import { render, staticRenderFns } from "./CertificationAgencyList.vue?vue&type=template&id=10b9f7b5&scoped=true&"
import script from "./CertificationAgencyList.vue?vue&type=script&lang=js&"
export * from "./CertificationAgencyList.vue?vue&type=script&lang=js&"
import style0 from "./CertificationAgencyList.vue?vue&type=style&index=0&id=10b9f7b5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9f7b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
